module.exports = __webpack_public_path__ + "entry-41b28522/qrcode-86ebc6a6ef56a670acf49e7e91b0e030.svg";